export default function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime/helpers/esm/nonIterableRest.js
// module id = 770
// module chunks = 121